export default __webpack_public_path__ + "static/media/411.f5cb0dad.png";